import { firebase } from 'src/firebase';

class StorageHelper {
  metadata: {};

  constructor(meta?: {}) {
    this.metadata = {
      contentType: 'image/jpeg',
      ...meta,
    };
  }

  getRef() {
    return firebase.storage().ref();
  }

  createChild(path: string) {
    const storageRef = this.getRef();
    return storageRef.child(path);
  }

  async upload(path: string, file: Blob): Promise<string> {
    try {
      const metadata = this.metadata;
      const child = this.createChild(path);
      const uploadTask = await child.put(file, metadata);
      const downloadURL = await uploadTask.ref.getDownloadURL();
      return downloadURL;
    } catch (err) {
      throw err;
    }
  }
}

export default StorageHelper;
